/* eslint-disable max-len */
import React from 'react';

export const DisLike = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0625 3.69981H5.86665C5.57209 3.69981 5.33331 3.93859 5.33331 4.23314V9.90671C5.33331 10.0315 5.37706 10.1523 5.45693 10.2481L7.99998 13.2998H9.1377C9.51777 13.2998 9.77587 12.9136 9.63046 12.5624L8.36541 9.50721H10.716H12.8C13.0945 9.50721 13.3333 9.26843 13.3333 8.97388V8.09572C13.3333 8.02029 13.3173 7.94572 13.2864 7.87693L11.5489 4.01435C11.4628 3.82292 11.2724 3.69981 11.0625 3.69981Z" fill="#AFAFAF" stroke="#AFAFAF" strokeWidth="0.533333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.00002 9.8335V3.96683H2.93335V9.8335H4.00002Z" stroke="#AFAFAF" strokeWidth="1.06667" strokeLinejoin="round" />
  </svg>
);
